<template>
    <div class="changelog-entry-view" data-testid="changelog-entry-view">
        <div class="row">
            <div class="col-xs-12">
                <p>
                    <a href="" data-testid="changelog-entry-back" @click.prevent="onBack()">
                        &laquo; What's New
                    </a>
                </p>
            </div>
        </div>
        <div v-if="error" class="row">
            <div class="col-xs-12">
                <div class="alert alert-danger">{{ error }}</div>
            </div>
        </div>
        <div class="row">
            <div class="col-xs-12">
                <p v-if="loading" data-testid="changelog-entry-loading">Loading...</p>
                <p v-if="!loading && notFound" data-testid="changelog-entry-not-found">
                    This update could not be found.
                </p>
                <article v-if="!loading && entry" data-testid="changelog-entry-article">
                    <header>
                        <h1>{{ entry.title }}</h1>
                        <p class="text-muted">
                            <span data-testid="changelog-entry-published">
                                Published {{ formatDate(entry.published_at) }}
                            </span>
                            <span v-if="showUpdated" data-testid="changelog-entry-updated">
                                &middot; Updated {{ formatDate(entry.updated_at) }}
                            </span>
                        </p>
                    </header>
                    <!-- body_html is rendered and sanitized by the API -->
                    <div class="changelog-entry-body" v-html="entry.body_html"></div>
                </article>
            </div>
        </div>
    </div>
</template>

<script>
// An entry counts as "updated" only when it was edited meaningfully after
// publishing; smaller gaps are pre-publish touch-ups not worth surfacing.
const UPDATED_THRESHOLD_MS = 60 * 60 * 1000;

export default {
    name: 'ChangelogEntryView',
    props: {
        entry: {
            type: Object,
            default: null
        },
        loading: {
            type: Boolean,
            default: false
        },
        error: {
            type: String,
            default: ''
        },
        notFound: {
            type: Boolean,
            default: false
        },
        onBack: {
            type: Function,
            required: true
        }
    },
    computed: {
        showUpdated() {
            if (!this.entry || !this.entry.updated_at || !this.entry.published_at) {
                return false;
            }
            const updatedAt = new Date(this.entry.updated_at).getTime();
            const publishedAt = new Date(this.entry.published_at).getTime();
            return updatedAt - publishedAt > UPDATED_THRESHOLD_MS;
        }
    },
    methods: {
        formatDate(value) {
            if (!value) {
                return '';
            }
            return new Date(value).toLocaleDateString(undefined, {
                year: 'numeric',
                month: 'long',
                day: 'numeric'
            });
        }
    }
};
</script>

<style scoped>
.changelog-entry-view header h1 {
    margin-bottom: 2px;
}

.changelog-entry-view .text-muted {
    margin-bottom: 12px;
}

.changelog-entry-body {
    max-width: 720px;
}
</style>
